export default __webpack_public_path__ + "static/media/1Blog.6e7e6899.png";